import { capacitor, createAndroidWriter } from './androidWriter'
import { bridgeWriter } from './bridgeWriter'
import type { NfcWriter } from './types'

/** Installer / app download locations (served by the web host; the files are published separately). */
export const DOWNLOADS = {
  windows: '/downloads/motores-nfc-bridge-windows.exe',
  linux: '/downloads/motores-nfc-bridge-linux-install.sh',
  android: '/downloads/motores-campo.apk',
} as const

export type Os = 'windows' | 'linux' | 'android' | 'other'

export function detectOs(userAgent: string): Os {
  if (/android/i.test(userAgent)) return 'android' // Android UAs also contain "Linux"
  if (/windows/i.test(userAgent)) return 'windows'
  if (/linux|x11/i.test(userAgent)) return 'linux'
  return 'other'
}

export function isAndroidShell(): boolean {
  return capacitor()?.isNativePlatform?.() === true
}

/** Android shell -> plugin; otherwise the desktop bridge (whether it is really running is probed by polling). */
export function detectWriter(): NfcWriter {
  return isAndroidShell() ? createAndroidWriter() : bridgeWriter
}
